const homepage = {
  path: 'homepage',
  component: resolve => require(['../../../../components/pages/register/homepage'], resolve)
}

export default homepage
